import Layout from '@/views/Layout/AppContent.vue'
import LayoutTo from '@/views/Layout/AppContentTo.vue'
/* 使用了children，但实际使用只需要一级菜单的情况，children中的meta不要加title属性 */
/* meta.name用于进行菜单高亮显示，相同的name则高亮同一个菜单 */
const router = [
  /* 首页 */
  {
    path: '/overview',
    redirect: '/overview/index',
    name: 'overview',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/Overview/index.vue'),
        meta: {
          name: 'overview'
        }
      },
      {
        path: 'approvalOpinion',
        component: () => import('@/views/Overview/approvalOpinion.vue'),
        meta: {
          title: '审批记录',
          name: 'approvalOpinion',
          hidden: true
        }
      }
    ],
    meta: { title: '首页', name: 'overview', icon: 's-home' }
  },
  /* 综合管理 */
  {
    path: '/comprehensive',
    name: 'comprehensive',
    component: Layout,
    children: [
      {
        path: 'certificates',
        name: 'certificates',
        component: LayoutTo,
        children: [
          {
            path: 'maintainIndex',
            component: () => import('@/views/comprehensive/certificates/maintain/index.vue'),
            meta: {
              title: '证件维护',
              name: 'maintainIndex',
              icon: 'edit'
            }
          },
          {
            path: 'record',
            component: () => import('@/views/comprehensive/certificates/record/index.vue'),
            meta: {
              title: '申请记录',
              name: 'record',
              icon: 'tickets'
            }
          },
        ],
        meta: { title: '证件管理', name: 'certificates', icon: 'postcard' }
      },
      {
        path: 'checkWork',
        name: 'checkWork',
        component: LayoutTo,
        children: [
          {
            path: 'calendar',
            component: () => import('@/views/comprehensive/checkWork/calendar/index.vue'),
            meta: {
              title: '日历设置',
              name: 'calendar',
              icon: 'date'
            }
          },
          {
            path: 'clockSettings',
            component: () => import('@/views/comprehensive/checkWork/clockSettings/index.vue'),
            meta: {
              title: '打卡设置',
              name: 'clockSettings',
              icon: 'setting'
            }
          },
          {
            path: 'auditList',
            component: () => import('@/views/comprehensive/checkWork/auditList/index.vue'),
            meta: {
              title: '异常考勤审核',
              name: 'auditList',
              icon: 'coordinate'
            }
          },
          {
            path: 'attendanceSummary',
            component: () => import('@/views/comprehensive/checkWork/attendanceSummary/index.vue'),
            meta: {
              title: '考勤汇总',
              name: 'attendanceSummary',
              icon: 'tickets'
            }
          },
          {
            path: 'attendanceDetails',
            component: () => import('@/views/comprehensive/checkWork/attendanceDetails/index.vue'),
            meta: {
              title: '个人考勤明细',
              name: 'attendanceDetails',
              icon: 'user'
            }
          },
          {
            path: 'myOverTime',
            component: () => import('@/views/comprehensive/overTime/myOverTime.vue'),
            meta: {
              title: '加班明细',
              name: 'myOverTime',
              icon: 'edit'
            }
          },
          {
            path: 'allOverTime',
            component: () => import('@/views/comprehensive/overTime/allOverTime.vue'),
            meta: {
              title: '加班汇总',
              name: 'allOverTime',
              icon: 'tickets'
            }
          },
          {
            path: 'leaveTimeDetailed',
            component: () => import('@/views/comprehensive/leaveTime/leaveTime.vue'),
            meta: {
              title: '请假明细',
              name: 'leaveTimeDetailed',
              icon: 'edit'
            }
          },
        ],
        meta: { title: '考勤管理', name: 'checkWork', icon: 'time' }
      },
      {
        path: 'talentManagement',
        component: () => import('@/views/comprehensive/talent/talentManagement.vue'),
        meta: {
          title: '人才管理',
          name: 'talentManagement',
          icon: 's-custom'
        }
      },
      {
        path: 'sealManagement',
        component: () => import('@/views/comprehensive/sealManagement/index.vue'),
        meta: {
          title: '用章管理',
          name: 'sealManagement',
          icon: 's-check'
        }
      },
      {
        path: 'reimbursement',
        name: 'reimbursement',
        component: LayoutTo,
        children: [
          {
            path: 'reimbursementDetailed',
            component: () => import('@/views/comprehensive/reimbursement/detailed/index.vue'),
            meta: {
              title: '报销明细',
              name: 'reimbursementDetailed',
              icon: 'edit'
            }
          },
          {
            path: 'reimbursementSummary',
            component: () => import('@/views/comprehensive/reimbursement/summary/index.vue'),
            meta: {
              title: '报销汇总',
              name: 'reimbursementSummary',
              icon: 'tickets'
            }
          },
        ],
        meta: { title: '报销管理', name: 'reimbursement', icon: 's-finance' }
      },
      {
        path: 'carManagement',
        name: 'carManagement',
        component: LayoutTo,
        children: [
          {
            path: 'carInfo',
            component: () => import('@/views/comprehensive/carManagement/carInfo/index.vue'),
            meta: {
              title: '车辆管理',
              name: 'carInfo',
              icon: 'edit'
            }
          },
          {
            path: 'carApplication',
            component: () => import('@/views/comprehensive/carManagement/carApplication/index.vue'),
            meta: {
              title: '用车申请',
              name: 'carApplication',
              icon: 'tickets'
            }
          },
        ],
        meta: { title: '用车管理', name: 'carManagement', icon: 'truck' }
      },
      // {
      //   path: 'overTime',
      //   name: 'overTime',
      //   component: LayoutTo,
      //   children: [
      //     {
      //       path: 'myOverTime',
      //       component: () => import('@/views/comprehensive/overTime/myOverTime.vue'),
      //       meta: {
      //         title: '加班明细',
      //         name: 'myOverTime',
      //         icon: 'edit'
      //       }
      //     },
      //     {
      //       path: 'allOverTime',
      //       component: () => import('@/views/comprehensive/overTime/allOverTime.vue'),
      //       meta: {
      //         title: '加班汇总',
      //         name: 'allOverTime',
      //         icon: 'tickets'
      //       }
      //     },
      //   ],
      //   meta: { title: '加班管理', name: 'overTime', icon: 'table-lamp' }
      // },
      // {
      //   path: 'leaveTime',
      //   name: 'leaveTime',
      //   component: LayoutTo,
      //   children: [
      //     {
      //       path: 'leaveTimeDetailed',
      //       component: () => import('@/views/comprehensive/leaveTime/leaveTime.vue'),
      //       meta: {
      //         title: '请假明细',
      //         name: 'leaveTimeDetailed',
      //         icon: 'edit'
      //       }
      //     },
      //   ],
      //   meta: { title: '请假管理', name: 'leaveTime', icon: 'date' }
      // },
      {
        path: 'commonApproval',
        component: () => import('@/views/comprehensive/commonApproval/index.vue'),
        meta: {
          title: '通用审批管理',
          name: 'commonApproval',
          icon: 'setting'
        }
      },
      {
        path: 'assetsManagement',
        name: 'assetsManagement',
        component: LayoutTo,
        children: [
          {
            path: 'fixedAssets',
            component: () => import('@/views/comprehensive/assetsManagement/fixedAssets/index.vue'),
            meta: {
              title: '固定资产',
              name: 'fixedAssets',
              icon: 'tickets'
            }
          },
          {
            path: 'assetsclaim',
            component: () => import('@/views/comprehensive/assetsManagement/assetsclaim/index.vue'),
            meta: {
              title: '资产申领',
              name: 'assetsclaim',
              icon: 'document'
            }
          },
          {
            path: 'assetPurchase',
            component: () => import('@/views/comprehensive/assetsManagement/assetPurchase/index.vue'),
            meta: {
              title: '资产采购',
              name: 'assetPurchase',
              icon: 'document-copy'
            }
          },
        ],
        meta: { title: '资产管理', name: 'assetsManagement', icon: 'coin' }
      },
      {
        path: 'intentionLeave',
        component: () => import('@/views/comprehensive/intentionLeave/index.vue'),
        meta: {
          title: '意向留言管理',
          name: 'intentionLeave',
          icon: 'chat-dot-square'
        }
      },
      {
        path: 'writManagement',
        name: 'writManagement',
        component: LayoutTo,
        children: [
          {
            path: 'noticeManagement',
            component: () => import('@/views/basicInfo/noticeManagement.vue'),
            meta: {
              title: '公示管理',
              name: 'noticeManagement',
              icon: 'chat-square'
            }
          },
          {
            path: 'institution',
            component: () => import('@/views/basicInfo/institution.vue'),
            meta: {
              title: '制度管理',
              name: 'institution',
              icon: 'tickets'
            }
          },
          {
            path: 'inform',
            component: () => import('@/views/basicInfo/informManagement.vue'),
            meta: {
              title: '通知管理',
              name: 'inform',
              icon: 'news'
            }
          }
        ],
        meta: { title: '文书管理', name: 'writManagement', icon: 'reading' }
      },
      {
        path: 'operationLog',
        component: () => import('@/views/comprehensive/operationLog/operationLog.vue'),
        meta: {
          title: '操作日志',
          name: 'operationLog',
          icon: 'edit-outline'
        }
      },
    ],
    meta: { title: '综合管理', name: 'comprehensive', icon: 's-management' }
  },
  /* 基础信息 */
  {
    path: '/basicInfo',
    redirect: '/basicInfo/account',
    name: 'basicInfo',
    component: Layout,
    children: [
      {
        path: 'account',
        component: () => import('@/views/basicInfo/accountPage.vue'),
        meta: {
          title: '账号管理',
          name: 'accountPage',
          icon: 's-custom'
        }
      },
      {
        path: 'role',
        component: () => import('@/views/basicInfo/role.vue'),
        meta: {
          title: '角色管理',
          name: 'role',
          icon: 's-opportunity'
        }
      },
      {
        path: 'company',
        component: () => import('@/views/basicInfo/company.vue'),
        meta: {
          title: '公司信息',
          name: 'company',
          icon: 'document-copy'
        }
      },
      {
        path: 'companyAccount',
        component: () => import('@/views/basicInfo/companyAccount.vue'),
        meta: {
          title: '账户信息',
          name: 'companyAccount',
          icon: 'notebook-2'
        }
      },
      {
        path: 'process',
        component: () => import('@/views/basicInfo/process.vue'),
        meta: {
          title: '流程配置',
          name: 'process',
          icon: 'setting'
        }
      },
      {
        path: 'tenantCompanies',
        component: () => import('@/views/basicInfo/tenantCompanies.vue'),
        meta: {
          title: '承租企业',
          name: 'tenantCompanies',
          icon: 'office-building'
        }
      },
      {
        path: 'parkManagement',
        component: () => import('@/views/basicInfo/parkManagement.vue'),
        meta: {
          title: '园区管理',
          name: 'parkManagement',
          icon: 'office-building'
        }
      },
      {
        path: 'building',
        component: () => import('@/views/basicInfo/building.vue'),
        meta: {
          title: '楼宇信息',
          name: 'building',
          icon: 'office-building'
        }
      },
      {
        path: 'buildManagement',
        component: () => import('@/views/basicInfo/buildManagement.vue'),
        meta: {
          title: '房屋管理',
          name: 'buildManagement',
          icon: 'school'
        }
      },
    ],
    meta: { title: '基础信息', name: 'basicInfo', icon: 'c-scale-to-original' }
  },
  /* 合同信息 */
  {
    path: '/contract',
    redirect: '/contract/template',
    name: 'contract',
    component: Layout,
    children: [
      {
        path: 'template',
        component: () => import('@/views/contract/templatePage.vue'),
        meta: {
          title: '模板管理',
          name: 'templatePage',
          icon: 'document'
        }
      },
      {
        path: 'management',
        component: () => import('@/views/contract/contractManagePage.vue'),
        meta: {
          title: '合同管理',
          name: 'contractManagePage',
          icon: 's-check'
        }
      },
      {
        path: 'history',
        component: () => import('@/views/contract/historyContract.vue'),
        meta: {
          title: '合同归档',
          name: 'contractHistory',
          icon: 's-check'
        }
      },
      {
        path: 'major',
        component: () => import('@/views/contract/majorProject.vue'),
        meta: {
          title: '重大项目',
          name: 'majorProject',
          icon: 's-check'
        }
      },
      {
        path: 'addTemplate',
        component: () => import('@/views/contract/addTemplate.vue'),
        meta: {
          title: '新增/编辑模板',
          name: 'addTemplate',
          hidden: true
        }
      },
      {
        path: 'addContract',
        component: () => import('@/views/contract/addContract.vue'),
        meta: {
          title: '新增/编辑合同',
          name: 'addContract',
          hidden: true
        }
      },
      {
        path: 'previewContract',
        component: () => import('@/views/contract/previewContract.vue'),
        meta: {
          title: '打印合同',
          name: 'previewContract',
          hidden: true
        }
      },
      {
        path: 'taxManagement',
        component: () => import('@/views/contract/taxManagement.vue'),
        meta: {
          title: '税务管理',
          name: 'taxManagement',
          icon: 's-check'
        }
      },
      {
        path: 'addTax',
        component: () => import('@/views/contract/addTax.vue'),
        meta: {
          title: '凭证录入',
          name: 'addTax',
          hidden: true
        }
      },
    ],
    meta: { title: '合同信息', name: 'contract', icon: 'document' }
  },
  /* 党建管理 */
  {
    path: '/partyBuilding',
    redirect: '/partyBuilding/partyMember',
    name: 'partyBuilding',
    component: Layout,
    children: [
      {
        path: 'partyMember',
        component: () => import('@/views/partyBuilding/partyMember.vue'),
        meta: {
          title: '党员管理',
          name: 'partyMember',
          icon: 's-custom'
        }
      },
      {
        path: 'partyNewInfo',
        component: () => import('@/views/partyBuilding/partyNewInfo.vue'),
        meta: {
          title: '党建动态',
          name: 'partyNewInfo',
          icon: 's-custom'
        }
      },
      {
        path: 'addParty',
        component: () => import('@/views/partyBuilding/addPartyInfo.vue'),
        meta: {
          title: '动态发布',
          name: 'addPartyInfo',
          hidden: true
        }
      },
    ],
    meta: { title: '党建管理', name: 'partyBuilding', icon: 's-home' }
  },
  {
    path: '/community',
    redirect: '/community/productionTeam',
    name: 'community',
    component: Layout,
    children: [
      {
        path: 'productionTeam',
        component: () => import('@/views/community/productionTeam'),
        meta: {
          title: '生产队维护',
          name: 'productionTeam',
          icon: 's-flag'
        }
      },
      {
        path: 'Information',
        component: () => import('@/views/community/InformationOld'),
        meta: {
          title: '信息登记',
          name: 'Information',
          icon: 's-claim'
        }
      },
      {
        path: 'memberSummary',
        component: () => import('@/views/community/memberSummary'),
        meta: {
          title: '成员汇总',
          name: 'memberSummary',
          icon: 's-custom'
        }
      },
      // {
      //   path: 'shareDetailed',
      //   component: () => import('@/views/community/shareDetailed'),
      //   meta: {
      //     title: '股份份额明细',
      //     name: 'shareDetailed',
      //     icon: 's-order'
      //   }
      // },
    ],
    meta: { title: '经联社管理', name: 'community', icon: 'coin' }
  },
  // /* 新增编辑模板 */
  // {
  //   path: '/contract',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'addTemplate',
  //       component: () => import('@/views/contract/addTemplate.vue'),
  //       meta: {
  //         title: '新增/编辑模板',
  //         name: 'addTemplate'
  //       }
  //     }
  //     // {
  //     //   path: 'previewTemplate',
  //     //   component: () => import('@/views/contract/previewTemplate.vue'),
  //     //   meta: {
  //     //     title: '预览模板',
  //     //     name: 'previewTemplate'
  //     //   }
  //     // }
  //   ],
  //   meta: { title: '模板管理', name: 'addTemplate', hidden: true }
  // },
  // /* 新增编辑合同 */
  // {
  //   path: '/contract',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'addContract',
  //       component: () => import('@/views/contract/addContract.vue'),
  //       meta: {
  //         title: '新增/编辑合同',
  //         name: 'addContract'
  //       }
  //     },
  //     {
  //       path: 'previewContract',
  //       component: () => import('@/views/contract/previewContract.vue'),
  //       meta: {
  //         title: '打印合同',
  //         name: 'previewContract'
  //       }
  //     }
  //   ],
  //   meta: { title: '合同管理', name: 'contractManagePage', hidden: true }
  // },
  /* 统计报表 */
  {
    path: '/report',
    redirect: '/report/houseRent',
    name: 'report',
    component: Layout,
    children: [
      {
        path: 'houseRent',
        component: () => import('@/views/report/houseRent.vue'),
        meta: {
          // title: '出租房屋租金收缴统计汇总表',
          title: '租金月度汇总',
          name: 'houseRent',
          icon: 'data-board'
        }
      },
      {
        path: 'buildingRent',
        component: () => import('@/views/report/buildingRent.vue'),
        meta: {
          // title: '楼宇出租房屋租金收缴统计表',
          title: '租金单列统计',
          name: 'buildingRent',
          icon: 'film'
        }
      },
      {
        path: 'forRent',
        component: () => import('@/views/report/forRent.vue'),
        meta: {
          title: '待租房屋明细',
          name: 'forRent',
          icon: 'house'
        }
      },
      // 打印租金月度汇总
      {
        path: 'printHouseRent',
        component: () => import('@/views/report/printHouseRent.vue'),
        meta: {
          title: '打印租金月度汇总',
          name: 'printHouseRent',
          hidden: true
        }
      },
      // 打印租金单列统计
      {
        path: 'printBuildingRent',
        component: () => import('@/views/report/printBuildingRent.vue'),
        meta: {
          title: '打印租金单列统计',
          name: 'printBuildingRent',
          hidden: true
        }
      },
      // 打印待租房屋明细
      {
        path: 'printForRent',
        component: () => import('@/views/report/printForRent.vue'),
        meta: {
          title: '打印待租房屋明细',
          name: 'printForRent',
          hidden: true
        }
      }
    ],
    meta: { title: '统计报表', name: 'report', icon: 'bank-card' }
  }
  // 基础信息
  //   {
  //     path: '/overview',
  //     redirect: '/overview/index',
  //     name: 'overview',
  //     component: Layout,
  //     children: [
  //       {
  //         path: 'index',
  //         component: () => import('@/views/Overview/index.vue'),
  //         meta: {
  //           name: 'overview'
  //         }
  //       }
  //     ],
  //     meta: { title: '首页', name: 'overview', icon: 'housefront' }
  //   },
  /* 设备管理 */
  // {
  //   path: '/device',
  //   redirect: '/device/list',
  //   name: 'device',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'list',
  //       component: () => import('@/views/Device/List.vue'),
  //       meta: {
  //         title: '设备列表',
  //         name: 'deviceList'
  //       }
  //     },
  //     {
  //       path: 'maintain',
  //       component: () => import('@/views/Device/Maintain.vue'),
  //       meta: {
  //         title: '设备维保管理',
  //         name: 'deviceMaintain'
  //       }
  //     }
  //   ],
  //   meta: { title: '设备管理', name: 'device', icon: 'wrench-fill' }
  // }
]
export default router
